import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/auction-charge/`;

// What "เก็บเงิน" would charge: { ready, reason, items[], total, balance, balanceAfter, chargedToday }
const preview = async ({ customerId, orderIds }) => {
  return await axios.post(API_URL + 'preview', { customerId, orderIds });
};

// Charge the wallet. expectedTotal = the total admin confirmed; a different server total → 409.
const charge = async ({ customerId, orderIds, expectedTotal }) => {
  return await axios.post(API_URL + 'charge', { customerId, orderIds, expectedTotal });
};

export default { preview, charge };
